import { css, html } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { Page } from "../enums/Page";
import { MiniGameComponent } from "./KeypadTrapcomponent";
const styles: string = css`
  :host {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
`;

export class ModalMiniGameComponent extends HTMLElement {
    private _gameEventService: GameEventService = new GameEventService();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) return;

        const element: HTMLElement = this.renderKeypad();

        this.shadowRoot.firstChild?.remove();
        this.shadowRoot.append(element);

        // Listen to events from <game-minigame>
        element.querySelector("game-minigame")?.addEventListener("submit", (e: Event) => {
            const customEvent: CustomEvent<{ value: string }> = e as CustomEvent<{ value: string }>;
            const detail: { value: string } = customEvent.detail;
            console.log("Submitted code:", detail.value);
            this._gameEventService.switchPage(Page.Canvas); // go back to canvas
        });

        element.querySelector("game-minigame")?.addEventListener("cancel", () => {
            this._gameEventService.switchPage(Page.Canvas); // just go back
        });
    }

    private renderKeypad(): HTMLElement {
        const element: HTMLElement = html`
      <div>
        <style>${styles}</style>
        <div>
          <game-minigame></game-minigame>
        </div>
      </div>
    `;
        return element;
    }
}

// customElements.define("game-modalminigame", ModalMiniGameComponent);
customElements.define("game-minigame", MiniGameComponent);
